export default __webpack_public_path__ + "static/elLogo-0893cdf3444adac1ee0038fa357a22d3.png";